import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import { lightTheme } from './themes/smartinventoryTheme';
import { ConfigProvider } from './components/shared/ConfigContext';
import { GoogleAuthProvider } from './components/shared/GoogleAuth';
import { installAxiosAuth } from './api/axiosSetup';
import { getAccessToken, scheduleProactiveRefresh } from './utils/authTokens';
import './i18n'; // keep this import before rendering
import '@fontsource/dm-sans/400.css';
import '@fontsource/dm-sans/500.css';
import '@fontsource/dm-sans/600.css';
import '@fontsource/dm-sans/700.css';
import './index.css';

// Resolved lazily once app-config.json loads, so the interceptors and the
// proactive refresh scheduler always use the configured backend URL.
let backendUrl = null;

installAxiosAuth(() => backendUrl);

fetch('/assets/app-config.json')
  .then((response) => response.json())
  .then((config) => {
    backendUrl = config.backendUrl;
    if (getAccessToken()) {
      scheduleProactiveRefresh(backendUrl);
    }
  })
  .catch((error) => console.error('Error loading config:', error));

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <ThemeProvider theme={lightTheme}>
    <ConfigProvider>
      <GoogleAuthProvider>
        <App />
      </GoogleAuthProvider>
    </ConfigProvider>
  </ThemeProvider>
);
